import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { List, Map, fromJS } from 'immutable';

import * as commonVar from 'libs/commonVar';
import { Segment, Grid, Button as SemanticButton, Icon, Popup } from 'semantic-ui-react';

import {
  TagItem,
  ModalTargetAdd,
  ModalTargetDelete,
  ModalTargetExcelUpload,
  ModalTargetExcelExport,
  Button
} from 'components';

import styles from './TargetHeader.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class TargetHeader extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      isModal,
      isClicked,
      selectedTag,
      selectTarget,
      totalTargetCount,
      tagDataByTagNo,
      targetDataByTargetNo,
      excelFileData,
      excelUploadResult,
      onAddTarget,
      onDeleteTarget,
      onExportTarget,
      onToggleModal,
      onTargetExcelDownload,
      onTargetExcelDrop,
      onTargetExcelSubmit,
      onTargetExcelReset,
      handleChange,
      handleChangeTag,
      registerTag,
      handleSearchChange,
      handleBlur,
      searchText
    } = this.props;
    let totalTagCount = selectedTag.size;

    let titleView;
    const TagArray = [];
    selectedTag.map(tagNo => {
      if (tagNo === 'all-tag') {
        totalTagCount = tagDataByTagNo.size;

        return (titleView = (
          <div key={tagNo} className={cx('targetHeader-selectTag')}>
            {defineMessages(formatMessage({ id: 'TargetHeader_1', defaultMessage: '모든 대상자' }))}
          </div>
        ));
      } else if (tagNo === 'no-tag') {
        totalTagCount = 0;

        return (titleView = (
          <div key={tagNo} className={cx('targetHeader-selectTag')}>
            {defineMessages(formatMessage({ id: 'TargetHeader_2', defaultMessage: '태그가 없는 대상자' }))}
          </div>
        ));
      } else if (typeof tagDataByTagNo.get(String(tagNo)) !== 'undefined') {
        titleView = (
          <div className={cx('targetHeader-tagTitle')} key={tagNo}>
            <div className={cx('ellipsis')}>
              <TagItem tagItem={tagDataByTagNo.get(String(selectedTag.get(0)))} />
            </div>
            {totalTagCount > 1 && (
              <div className={cx('targetHeader-subMessage')}>
                {defineMessages(formatMessage({ id: 'TargetHeader_3', defaultMessage: '외' })) +
                  ' ' +
                  defineMessages(formatMessage({ id: 'TargetHeader_11', defaultMessage: ' ' })) +
                  (totalTagCount - 1) +
                  defineMessages(formatMessage({ id: 'TargetHeader_4', defaultMessage: '개 태그' }))}
              </div>
            )}
          </div>
        );

        TagArray.push(<TagItem key={tagNo} tagItem={tagDataByTagNo.get(String(tagNo))} />);
      }
    });

    // 대상자 삭제 리스트
    let deleteTargetData = Map({});
    let exportTargetData = Map({});
    if (isModal === 'targetDelete') {
      deleteTargetData = Map({
        targetNoArray: selectTarget.get('targetNoArray')
      });
    } else if (isModal === 'targetExportExcel') {
      exportTargetData = Map({
        targetNoArray: selectTarget.get('targetNoArray')
      });
    }

    return (
      <div className={cx('targetHeader-wrapper')}>
        {/* 대상자 등록 모달 */}
        {isModal === 'targetAdd' && (
          <ModalTargetAdd
            visible
            isClicked={isClicked}
            onAddTarget={onAddTarget}
            onToggleModal={onToggleModal}
            handleChange={handleChange}
            tagDataByTagNo={tagDataByTagNo}
            handleChangeTag={handleChangeTag}
            registerTag={registerTag}
            handleSearchChange={handleSearchChange}
            handleBlur={handleBlur}
            searchText={searchText}
          />
        )}
        {/* 대상자 삭제 모달 */}
        {isModal === 'targetDelete' && (
          <ModalTargetDelete
            visible
            isClicked={isClicked}
            selectTarget={selectTarget}
            deleteTargetData={deleteTargetData}
            isAllCheck={selectTarget.get('isAllCheckTarget') === 2 ? 1 : 0}
            tagNoArray={selectedTag}
            tagDataByTagNo={tagDataByTagNo}
            totalTargetCount={totalTargetCount}
            targetDataByTargetNo={targetDataByTargetNo}
            onDeleteTarget={onDeleteTarget}
            onToggleModal={onToggleModal}
            handleChange={handleChange}
          />
        )}
        {/* 엑셀 업로드 모달 */}
        {isModal === 'targetAddExcel' && (
          <ModalTargetExcelUpload
            visible
            isClicked={isClicked}
            excelFileData={excelFileData}
            excelUploadResult={excelUploadResult}
            onToggleModal={onToggleModal}
            onTargetExcelDownload={onTargetExcelDownload}
            onTargetExcelDrop={onTargetExcelDrop}
            onTargetExcelSubmit={onTargetExcelSubmit}
            onTargetExcelReset={onTargetExcelReset}
          />
        )}
        {/* 엑셀 대상자 내보내기 모달 */}
        {isModal === 'targetExportExcel' && (
          <ModalTargetExcelExport
            visible
            isClicked={isClicked}
            selectTarget={selectTarget}
            exportTargetData={exportTargetData}
            isAllCheck={selectTarget.get('isAllCheckTarget') === 2 ? 1 : 0}
            tagNoArray={selectedTag}
            tagDataByTagNo={tagDataByTagNo}
            totalTargetCount={totalTargetCount}
            targetDataByTargetNo={targetDataByTargetNo}
            onExportTarget={onExportTarget}
            onToggleModal={onToggleModal}
            handleChange={handleChange}
          />
        )}
        <Segment vertical>
          <Grid columns="equal" stackable>
            <Grid.Row textAlign="left">
              <Grid.Column className={cx('targetHeader-column')}>
                {TagArray.length > 1 ? (
                  <Popup
                    className="max-250"
                    trigger={<div className={cx('targetHeader-Title')}>{titleView}</div>}
                    content={<div>{TagArray}</div>}
                    size="mini"
                    position="bottom left"
                  />
                ) : (
                    <div className={cx('targetHeader-Title')}>{titleView}</div>
                  )}
                <div className={cx('targetHeader-subTitle')}>
                  {defineMessages(formatMessage({ id: 'TargetHeader_5', defaultMessage: '총 대상자' })) +
                    ': ' +
                    totalTargetCount +
                    defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' })) +
                    ', ' +
                    defineMessages(formatMessage({ id: 'TargetHeader_6', defaultMessage: '태그' })) +
                    ': ' +
                    totalTagCount +
                    defineMessages(formatMessage({ id: 'TargetHeader_7', defaultMessage: '개' }))}
                </div>
              </Grid.Column>
              <Grid.Column className={cx('targetHeader-column', 'targetHeader-right')} textAlign="right">
                <SemanticButton.Group>
                  <Button
                    buttonColor="#d8d8d8"
                    fontSize="13"
                    fontColor="#414141"
                    onClick={() => {
                      onToggleModal('targetAdd');
                    }}>
                    {defineMessages(formatMessage({ id: 'TargetHeader_8', defaultMessage: '대상자 등록' }))}
                  </Button>
                  <Button
                    buttonColor="#d8d8d8"
                    fontSize="13"
                    fontColor="#414141"
                    disabled={selectTarget.get('targetNoArray').size === 0 ? true : false}
                    onClick={() => {
                      onToggleModal('targetDelete');
                    }}>
                    {defineMessages(formatMessage({ id: 'TargetHeader_9', defaultMessage: '대상자 삭제' }))}
                  </Button>
                </SemanticButton.Group>
                <div className={cx('ml-7', 'GroupBtn')}>
                  <Button
                    buttonColor="#d8d8d8"
                    fontSize="13"
                    fontColor="#757575"
                    onClick={() => {
                      onToggleModal('targetAddExcel');
                    }}>
                    {defineMessages(formatMessage({ id: 'TargetHeader_10', defaultMessage: '대상자 일괄 등록' }))}
                  </Button>
                  <Button
                    buttonColor="#d8d8d8"
                    fontSize="13"
                    fontColor="#757575"
                    onClick={() => {
                      onToggleModal('targetExportExcel');
                    }}>
                    {defineMessages(formatMessage({ id: 'TargetHeader_12', defaultMessage: '대상자 내보내기' }))}
                  </Button>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
}

TargetHeader.propTypes = {
  isModal: PropTypes.string,
  onAddTarget: PropTypes.func,
  onDeleteTarget: PropTypes.func,
  onExportTarget: PropTypes.func,
  onToggleModal: PropTypes.func,
  handleChange: PropTypes.func
};
TargetHeader.defaultProps = {};

export default injectIntl(TargetHeader);



// WEBPACK FOOTER //
// ./src/script/components/target/TargetHeader.js